var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEeur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#003399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1L12.2244 1.69098H12.9509L12.3632 2.11803L12.5877 2.80902L11.9999 2.38197L11.4121 2.80902L11.6366 2.11803L11.0488 1.69098H11.7754L11.9999 1Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45106 2.5L6.67557 3.19098H7.40211L6.81433 3.61803L7.03884 4.30902L6.45106 3.88197L5.86327 4.30902L6.08779 3.61803L5.5 3.19098H6.22654L6.45106 2.5Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95106 6L3.17557 6.69098H3.90211L3.31433 7.11803L3.53884 7.80902L2.95106 7.38197L2.36327 7.80902L2.58779 7.11803L2 6.69098H2.72654L2.95106 6Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99988 11L2.2244 11.691H2.95094L2.36316 12.118L2.58767 12.809L1.99988 12.382L1.4121 12.809L1.63661 12.118L1.04883 11.691H1.77537L1.99988 11Z",
    fill: "#FFCC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95106 16L3.17557 16.691H3.90211L3.31433 17.118L3.53884 17.809L2.95106 17.382L2.36327 17.809L2.58779 17.118L2 16.691H2.72654L2.95106 16Z",
    fill: "#FFCC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95106 19.5L7.17557 20.191H7.90211L7.31433 20.618L7.53884 21.309L6.95106 20.882L6.36327 21.309L6.58779 20.618L6 20.191H6.72654L6.95106 19.5Z",
    fill: "#FFCC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21L12.2244 21.691H12.9509L12.3632 22.118L12.5877 22.809L11.9999 22.382L11.4121 22.809L11.6366 22.118L11.0488 21.691H11.7754L11.9999 21Z",
    fill: "#FFCC00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9511 19.5L17.1756 20.191H17.9021L17.3143 20.618L17.5388 21.309L16.9511 20.882L16.3633 21.309L16.5878 20.618L16 20.191H16.7265L16.9511 19.5Z",
    fill: "#FFCC00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9511 16L21.1756 16.691H21.9021L21.3143 17.118L21.5388 17.809L20.9511 17.382L20.3633 17.809L20.5878 17.118L20 16.691H20.7265L20.9511 16Z",
    fill: "#FFCC00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 11L22.2244 11.691H22.9509L22.3632 12.118L22.5877 12.809L21.9999 12.382L21.4121 12.809L21.6366 12.118L21.0488 11.691H21.7754L21.9999 11Z",
    fill: "#FFCC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9511 6L21.1756 6.69098H21.9021L21.3143 7.11803L21.5388 7.80902L20.9511 7.38197L20.3633 7.80902L20.5878 7.11803L20 6.69098H20.7265L20.9511 6Z",
    fill: "#FFCC00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4511 2.5L17.6756 3.19098H18.4021L17.8143 3.61803L18.0388 4.30902L17.4511 3.88197L16.8633 4.30902L17.0878 3.61803L16.5 3.19098H17.2265L17.4511 2.5Z",
    fill: "#FFCC00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42887 11.2856C8.75983 9.65548 10.2011 8.42857 11.9288 8.42857C13.6566 8.42857 15.0978 9.65548 15.4288 11.2856H8.42887ZM6.97945 12.7142C7.32599 15.1373 9.40988 17 11.9288 17C13.2909 17 14.5271 16.4544 15.4281 15.5714C15.6183 15.385 15.7937 15.1835 15.9524 14.9688L14.8034 14.1198C14.69 14.2734 14.5645 14.4176 14.4283 14.5511C13.7834 15.183 12.9022 15.5714 11.9288 15.5714C10.201 15.5714 8.75968 14.3444 8.42882 12.7142H18.3571V11.2856H16.8782C16.5315 8.86258 14.4477 7 11.9288 7C9.40997 7 7.32614 8.86258 6.97949 11.2856H5.5V12.7142H6.97945Z",
    fill: "#FFCC00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEeur);
export default __webpack_public_path__ + "static/media/eeur.506ddcae66c8fc28089716bf6bd405ce.svg";
export { ForwardRef as ReactComponent };